/**
 * Lead Profile Creation
 */
import React, { useEffect, useState } from "react";

import ActivityBoard from "./ActivityBoard";
import PieChart from "./PieChart";
import ColumnGraph from "./ColumnGraph";
import StackedBar from "./StackedBar";
import SolidGauge from "./SolidGauge";
import BarGraph from "./BarGraph";
import LeadProfile from "../LeadProfile";
import Btn from "components/Custom/Btn";

import { INFO, LABELS, TITLES } from "common/lables";

import "./style/index.css";
import { COLORS } from "common/colors";
import { CRM_APIs } from "apihandlers/crm";
import { CRM_REPORTS_APIs } from "apihandlers/crm/reports";
import { CUSTOMER_APIs } from "apihandlers/customer";
import SkeletonBox from "components/Custom/SkeletonBox";

const map = require("assets/images/map.png");

interface defaultProps {}

const CrmDashboard = (props: any) => {
  const { setDashMenu } = props;
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCrmDashboard();
  }, []);

  const getCrmDashboard = async () => {
    try {
      const args = {
        activeStatus: "true",
        pageNo: 1,
      };

      const res: any = await CRM_REPORTS_APIs.getCrmDashboard(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response;
        // for (let i = 0; i < response.records.length; i++) {
        //   list[i]["stateName"] = list[i].stateName;
        //   list[i]["districtName"] = list[i].districtName;
        // }
        console.log("list", list);
        setGraphData(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getCrmDashboard:", error);
    }
  };

  console.log("graphdata", graphData);
  return !loading ? (
    <React.Fragment>
      <div className="userDashboard">
        <div className="pageInfo">
          <ul className="breadcrumbs">
            <li
              onClick={() => {
                setDashMenu(LABELS.HOME);
              }}
            >
              {LABELS.HOME}
            </li>
            <li className="dim">{" / "}</li>
            <li className="active">{TITLES.CRM_DASHBOARD}</li>
          </ul>
          <h4>{TITLES.CRM_DASHBOARD}</h4>
        </div>
        <div
          className="crmDashboard"
          style={{
            width: "98%",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              justifyContent: "space-between",
              height: window.innerHeight * 0.3,
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          >
            <div style={{ paddingLeft: 2, width: "31%" }}>
              <ColumnGraph height={window.innerHeight * 0.3} data={graphData} />
            </div>
            <div style={{ width: "31%" }}>
              <PieChart height={window.innerHeight * 0.3} data={graphData} />
            </div>
            <div style={{ width: "31%" }}>
              <BarGraph height={window.innerHeight * 0.3} data={graphData} />
            </div>
            {/* todo: Streetview make it work @keerthan  */}
            {/* <div
              className="width23"
              style={{
                display: "flex",
                flexDirection: "column",
                height: window.innerHeight * 0.3,
                position: "relative",
              }}
            >
              <img
                src={map}
                height={"100%"}
                style={{
                  border: "1px solid #ccc",
                  padding: 2,
                  borderRadius: 5,
                  width: "fit-content",
                  margin: "auto",
                }}
              />
              <a
                className="textShadow"
                href="/streetview"
                target="_new"
                style={{
                  position: "absolute",
                  bottom: 4,
                  left: "33%",
                  fontSize: "1rem",
                  fontWeight: "bold",
                }}
              >
                {INFO.CLICK_HERE_STREETVIEW}
              </a>
            </div> */}
          </div>
          <div>
            <Btn
              text={"Show Roi"}
              onClick={() => {
                setDashMenu(TITLES.ROI);
              }}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "75%" }}>
              <LeadProfile header={false} />
            </div>
            <div
              style={{
                width: "23%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  marginBottom: 0,
                }}
              >
                <StackedBar
                  height={window.innerHeight * 0.2}
                  data={graphData}
                />
                <SolidGauge
                  height={window.innerHeight * 0.2}
                  data={graphData}
                />
              </div>
              <div
                style={{
                  height: "40%",
                }}
              >
                {/* todo: make it work */}
                <ActivityBoard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <div className="userDashboard">
        <div className="pageInfo">
          <ul className="breadcrumbs">
            <li
              onClick={() => {
                setDashMenu(LABELS.HOME);
              }}
            >
              {LABELS.HOME}
            </li>
            <li className="dim">{" / "}</li>
            <li className="active">{TITLES.CRM_DASHBOARD}</li>
          </ul>
          <h4>{TITLES.CRM_DASHBOARD}</h4>
        </div>
        <div
          className="crmDashboard"
          style={{
            width: "98%",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              justifyContent: "space-between",
              height: window.innerHeight * 0.3,
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          >
            <div className="width23" style={{ paddingLeft: 2 }}>
              <SkeletonBox height={window.innerHeight * 0.3} width={"100%"} />
            </div>
            <div className="width23">
              <SkeletonBox height={window.innerHeight * 0.3} width={"100%"} />
            </div>
            <div className="width23">
              <SkeletonBox height={window.innerHeight * 0.3} width={"100%"} />
            </div>
            {/* <div
              className="width23"
              style={{
                display: "flex",
                flexDirection: "column",
                height: window.innerHeight * 0.3,
                position: "relative",
              }}
            >
              <SkeletonBox height={window.innerHeight * 0.3} width={"100%"} />
            </div> */}
          </div>
          <div style={{ width: "75%" }}>
            <SkeletonBox
              height={35}
              width={"10%"}
              style={{ marginBottom: 5, marginRight: 10 }}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "75%" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div className="flexRow" style={{ width: "25%" }}>
                  <SkeletonBox
                    height={30}
                    width={"45%"}
                    style={{ marginBottom: 5, marginRight: 10 }}
                  />
                  <SkeletonBox
                    height={30}
                    width={"45%"}
                    style={{ marginBottom: 5 }}
                  />
                </div>
                <div
                  className="flexRow"
                  style={{
                    width: "25%",
                    justifyContent: "flex-end",
                  }}
                >
                  <SkeletonBox
                    height={30}
                    width={"45%"}
                    style={{ marginBottom: 5, marginRight: 10 }}
                  />
                  <SkeletonBox
                    height={30}
                    width={"45%"}
                    style={{ marginBottom: 5 }}
                  />
                </div>
              </div>

              <SkeletonBox height={window.innerHeight * 0.5} width={"100%"} />
            </div>

            <div
              style={{
                width: "23%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  marginBottom: 0,
                }}
              >
                <SkeletonBox
                  height={window.innerHeight * 0.2}
                  width={"100%"}
                  style={{ marginBottom: 10 }}
                />
                <SkeletonBox
                  height={window.innerHeight * 0.15}
                  width={"100%"}
                  style={{ marginBottom: 10 }}
                />
              </div>
              <div
                style={{
                  height: "20%",
                }}
              >
                <SkeletonBox
                  height={window.innerHeight * 0.16}
                  width={"100%"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CrmDashboard;
